export const FILTER = {
  POPULAR: 'Phổ biến',
  BEST_SELLER: 'Bán chạy',
  HIGH_PRICE: 'Giá cao',
  LOW_PRICE: 'Giá thấp',
};

export const EMPTY_STATE = {
  TITLE: 'Không tìm thấy sản phẩm nào',
  MESSAGE: 'Chúng tôi sẽ sớm cập nhật sản phẩm mới cho bạn.',
};
